import React, { Component } from 'react';
import CreateASMPrize from './CreateASMPrize.js'; //component for creating ASM prizes/gifts
import EditASMPrize from './EditASMPrize.js'; //component for editing ASM prizes/gifts

export default class ManageASMPrizes extends Component {
	constructor(props){
		super(props);
		this.state = {newPrize:'',editedPrize:[],failed:false};
	}

	render(){

		let divStyles;
		const pStyles = "mt0 pt2 fl w-100 b navy mb3 bb b--light-silver";
		const picstyles= {display:'block', maxWidth:'100px',maxHeight:'122px',width:'auto',height:'auto',margin:'auto'};
		let spanStyle;
		let prizes;
		if(this.props.prizes !== undefined && this.props.prizes.length>0){ //display all ASM prizes/gifts for year selected
			if(!((this.props.create) || (this.props.edit))){ //if prize/gift inventory is lower than threshold set in LOV_ASM_Inventory table, highlight prize/gift in red
				prizes= this.props.prizes.map((prizes,i)=>{
					if(prizes.quantity <= prizes.threshold){
						spanStyle = "red";
						divStyles = "pa2 ba br3 overflow-y-auto ma3 bg-white shadow-3 b--red";
					}else{
						spanStyle = "";
						divStyles = "pa2 ba br3 overflow-y-auto ma3 bg-white shadow-3 b--navy";
					}
					return(<div className="fl w-50-ns mb2 w-100-m w-100 pa1" key={i}><div style={{maxWidth:'460px',margin:'auto'}} className={divStyles} key={prizes.prizeID}>
									<div className="fl w-60 pr2" style={{minHeight:'200px',maxHeight:'200px'}}>
										<p className="mt0 pt2 tc b navy underline">{prizes.prize}</p>
										<img src={prizes.picture} alt="error" style={picstyles}/>
										<p className="tc navy">{prizes.description}</p>
									</div>
									<div className="fl w-40">
										<div className="fl w-100">
											<p className={pStyles}>Tier: {prizes.tier}</p>
											<p className={pStyles}>Price: ${prizes.price.toFixed(2)}</p>
											<p className={pStyles}>Quantity: <span className={spanStyle}>{prizes.quantity}</span></p>
											<p className={pStyles}>Status: {prizes.status}</p>
										</div>
									</div>
								</div></div>);
				});
			}
		}else{ //if there have been no prizes/gifts created for the year selected, display this message
			prizes =  <p className="w-100 f3 tc">There is nothing to view at this time.</p>;
		}
		if(this.props.create){ //display CreateASMPrize
			prizes = <CreateASMPrize save={this.props.save} revertSave={this.props.revertSave} year={this.props.year} onClose={this.props.getPrizes}  logChange={this.props.logChange} tiers={this.props.tiers}/>
		}else if(this.props.edit){ //display EditASMPrize
			prizes = <EditASMPrize save={this.props.save} revertSave={this.props.revertSave} year={this.props.year} prizes={this.props.prizes} onClose={this.props.getPrizes}  reset={this.props.reset} tiers={this.props.tiers}/>
		}
		return(
			<div style={{maxWidth:'900px',margin:'auto'}}>
				{prizes}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ManageASMPrizes.js